import { render, staticRenderFns } from "./TechProcess.vue?vue&type=template&id=589d5143&scoped=true&"
import script from "./TechProcess.vue?vue&type=script&lang=js&"
export * from "./TechProcess.vue?vue&type=script&lang=js&"
import style0 from "./TechProcess.vue?vue&type=style&index=0&id=589d5143&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d5143",
  null
  
)

export default component.exports